const MAX_TITLE_LENGTH = 50;
const DEFAULT_TITLE = 'New Script';

export function deriveTitleFromContent(rawContent: string): string | null {
  const lines = rawContent.split('\n');
  for (const line of lines) {
    const stripped = line
      .replace(/^#{1,6}\s+/, '') // strip markdown headings
      .replace(/\*{1,2}([^*]+)\*{1,2}/g, '$1') // strip bold/italic
      .replace(/^---$/, '') // skip section dividers
      .trim();
    if (stripped.length > 0) {
      if (stripped.length <= MAX_TITLE_LENGTH) return stripped;
      return stripped.slice(0, MAX_TITLE_LENGTH) + '…';
    }
  }
  return null;
}

const MAX_SUBTITLE_LENGTH = 30;

export function deriveSectionSubtitle(content: string): string | null {
  const lines = content.split('\n');
  for (const line of lines) {
    const stripped = line
      .replace(/^#{1,6}\s+/, '')
      .replace(/\*{1,2}([^*]+)\*{1,2}/g, '$1')
      .replace(/^---$/, '')
      .trim();
    if (stripped.length > 0) {
      if (stripped.length <= MAX_SUBTITLE_LENGTH) return stripped;
      return stripped.slice(0, MAX_SUBTITLE_LENGTH) + '…';
    }
  }
  return null;
}

export function isDefaultTitle(title: string): boolean {
  return title.trim() === DEFAULT_TITLE;
}
